import { render, staticRenderFns } from "./StockAvailabilityTable2.vue?vue&type=template&id=3b7c8dc7"
import script from "./StockAvailabilityTable2.vue?vue&type=script&lang=ts"
export * from "./StockAvailabilityTable2.vue?vue&type=script&lang=ts"
import style0 from "./StockAvailabilityTable2.vue?vue&type=style&index=0&id=3b7c8dc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports